/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../API";
type GeneratedSubscription<InputType, OutputType> = string & {
  __generatedSubscriptionInput: InputType;
  __generatedSubscriptionOutput: OutputType;
};

export const onCreateAssessed = /* GraphQL */ `subscription OnCreateAssessed {
  onCreateAssessed {
    ID
    AssessmentID
    UserID
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateAssessedSubscriptionVariables,
  APITypes.OnCreateAssessedSubscription
>;
export const onCreateAssessment = /* GraphQL */ `subscription OnCreateAssessment {
  onCreateAssessment {
    ID
    Title
    BranchID
    Assessor
    Created
    TrainingType
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateAssessmentSubscriptionVariables,
  APITypes.OnCreateAssessmentSubscription
>;
export const onCreateAssessmentDetail = /* GraphQL */ `subscription OnCreateAssessmentDetail {
  onCreateAssessmentDetail {
    ID
    Conditions
    Results
    Reference
    AssessmentID
    IsTemplate
    Location
    Scenario
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateAssessmentDetailSubscriptionVariables,
  APITypes.OnCreateAssessmentDetailSubscription
>;
export const onCreateAssessmentTask = /* GraphQL */ `subscription OnCreateAssessmentTask {
  onCreateAssessmentTask {
    ID
    AssessmentID
    TaskID
    Rating
    SpecificNeeds
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateAssessmentTaskSubscriptionVariables,
  APITypes.OnCreateAssessmentTaskSubscription
>;
export const onCreateAssessmentTaskPerformanceStep = /* GraphQL */ `subscription OnCreateAssessmentTaskPerformanceStep {
  onCreateAssessmentTaskPerformanceStep {
    ID
    ATID
    PSID
    Rating
    SpecificNeeds
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateAssessmentTaskPerformanceStepSubscriptionVariables,
  APITypes.OnCreateAssessmentTaskPerformanceStepSubscription
>;
export const onCreateAssessmentTaskSubTaskPerformanceStep = /* GraphQL */ `subscription OnCreateAssessmentTaskSubTaskPerformanceStep {
  onCreateAssessmentTaskSubTaskPerformanceStep {
    ID
    ATSTID
    PSID
    Rating
    SpecificNeeds
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateAssessmentTaskSubTaskPerformanceStepSubscriptionVariables,
  APITypes.OnCreateAssessmentTaskSubTaskPerformanceStepSubscription
>;
export const onCreateAssessmentTaskSubTask = /* GraphQL */ `subscription OnCreateAssessmentTaskSubTask {
  onCreateAssessmentTaskSubTask {
    ID
    AssessmentTaskID
    SubTaskID
    Rating
    SpecificNeeds
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateAssessmentTaskSubTaskSubscriptionVariables,
  APITypes.OnCreateAssessmentTaskSubTaskSubscription
>;
export const onCreateBranch = /* GraphQL */ `subscription OnCreateBranch {
  onCreateBranch {
    ID
    SiteID
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateBranchSubscriptionVariables,
  APITypes.OnCreateBranchSubscription
>;
export const onCreateBranchUser = /* GraphQL */ `subscription OnCreateBranchUser {
  onCreateBranchUser {
    ID
    BranchID
    UserID
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateBranchUserSubscriptionVariables,
  APITypes.OnCreateBranchUserSubscription
>;
export const onCreateMET = /* GraphQL */ `subscription OnCreateMET {
  onCreateMET {
    ID
    Name
    TaskID
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateMETSubscriptionVariables,
  APITypes.OnCreateMETSubscription
>;
export const onCreatePerformanceStep = /* GraphQL */ `subscription OnCreatePerformanceStep {
  onCreatePerformanceStep {
    ID
    Name
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreatePerformanceStepSubscriptionVariables,
  APITypes.OnCreatePerformanceStepSubscription
>;
export const onCreateQuarterlyAssessmentDetail = /* GraphQL */ `subscription OnCreateQuarterlyAssessmentDetail {
  onCreateQuarterlyAssessmentDetail {
    ID
    StartDate
    EndDate
    AssessmentID
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateQuarterlyAssessmentDetailSubscriptionVariables,
  APITypes.OnCreateQuarterlyAssessmentDetailSubscription
>;
export const onCreateRank = /* GraphQL */ `subscription OnCreateRank {
  onCreateRank {
    ID
    Value
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateRankSubscriptionVariables,
  APITypes.OnCreateRankSubscription
>;
export const onCreateSite = /* GraphQL */ `subscription OnCreateSite {
  onCreateSite {
    ID
    Name
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateSiteSubscriptionVariables,
  APITypes.OnCreateSiteSubscription
>;
export const onCreateSiteUser = /* GraphQL */ `subscription OnCreateSiteUser {
  onCreateSiteUser {
    ID
    SiteID
    UserID
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateSiteUserSubscriptionVariables,
  APITypes.OnCreateSiteUserSubscription
>;
export const onCreateSiteAdmin = /* GraphQL */ `subscription OnCreateSiteAdmin {
  onCreateSiteAdmin {
    ID
    SiteID
    UserID
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateSiteAdminSubscriptionVariables,
  APITypes.OnCreateSiteAdminSubscription
>;
export const onCreateSubTask = /* GraphQL */ `subscription OnCreateSubTask {
  onCreateSubTask {
    ID
    ParentID
    ChildID
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateSubTaskSubscriptionVariables,
  APITypes.OnCreateSubTaskSubscription
>;
export const onCreateSubmitToken = /* GraphQL */ `subscription OnCreateSubmitToken {
  onCreateSubmitToken {
    ID
    Token
    Time
    UserID
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateSubmitTokenSubscriptionVariables,
  APITypes.OnCreateSubmitTokenSubscription
>;
export const onCreateTask = /* GraphQL */ `subscription OnCreateTask {
  onCreateTask {
    ID
    Name
    Number
    Level
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateTaskSubscriptionVariables,
  APITypes.OnCreateTaskSubscription
>;
export const onCreateTaskPerformanceStep = /* GraphQL */ `subscription OnCreateTaskPerformanceStep {
  onCreateTaskPerformanceStep {
    ID
    TaskID
    PSID
    SequenceNumber
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateTaskPerformanceStepSubscriptionVariables,
  APITypes.OnCreateTaskPerformanceStepSubscription
>;
export const onCreateUnit = /* GraphQL */ `subscription OnCreateUnit {
  onCreateUnit {
    ID
    Depth
    Name
    LeaderID
    ParentUnitID
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateUnitSubscriptionVariables,
  APITypes.OnCreateUnitSubscription
>;
export const onCreateUnitBranch = /* GraphQL */ `subscription OnCreateUnitBranch {
  onCreateUnitBranch {
    ID
    UnitID
    BranchID
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateUnitBranchSubscriptionVariables,
  APITypes.OnCreateUnitBranchSubscription
>;
export const onCreateUnitTask = /* GraphQL */ `subscription OnCreateUnitTask {
  onCreateUnitTask {
    ID
    UnitID
    TaskID
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateUnitTaskSubscriptionVariables,
  APITypes.OnCreateUnitTaskSubscription
>;
export const onCreateUser = /* GraphQL */ `subscription OnCreateUser {
  onCreateUser {
    ID
    Rank
    Name
    Email
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateUserSubscriptionVariables,
  APITypes.OnCreateUserSubscription
>;
